/* eslint-disable @typescript-eslint/no-explicit-any */

export const debounce = (callback: any, delay = 300): any => {
  let timer: any;

  return (...args: any[]) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};
